import { getCloudinaryUrl } from "@/lib/cloudinary";
import { type ServiceSection } from "../types";

export const soireesAThemesService: ServiceSection = {
  id: "soirees-a-themes",
  bannerImage: getCloudinaryUrl("soiree-beaute-tarot-divinatoire-1"),
  bannerTitle: "Soirées à Thèmes",
  keywords: [
    "soirées bien-être villejuif",
    "événements relaxation ville d'avray",
    "voyage sonore val de marne",
    "tarot divinatoire 94800",
    "soirées thématiques coiffure",
    "événements salon 92410",
  ],
  firstSection: {
    imagePath: getCloudinaryUrl("soiree-duo-tarot-divinatoire-voyage-sonore-1"),
    title:
      "Soirées à Thèmes : Événements Bien-être à Villejuif (94) et Ville d'Avray (92)",
    content: [
      {
        type: "paragraph",
        segments: [
          {
            text: "Les Soirées à Thèmes des salons Alexandra Grey sont des moments uniques de partage et de bien-être. Organisées régulièrement dans nos salons de Villejuif et Ville d'Avray, ces événements vous invitent à vivre des expériences immersives autour de la relaxation, du développement personnel et de la reconnexion à soi.",
          },
        ],
      },
      {
        type: "paragraph",
        segments: [
          {
            text: "Chaque soirée est pensée pour créer un espace de convivialité et de détente, mêlant massages, voyages sonores, tarot divinatoire, ateliers bien-être et moments gourmands. Un cadre chaleureux pour se ressourcer entre femmes.",
          },
        ],
      },
      {
        type: "paragraph",
        segments: [
          { text: "Notre promesse", isBold: true },
          {
            text: " : des soirées authentiques, bienveillantes et transformatrices, pour prendre soin de soi autrement.",
          },
        ],
      },
    ],
  },
  secondSection: {
    title: "Nos Soirées à Thèmes",
    content: [
      {
        type: "paragraph",
        segments: [
          {
            text: "Nos soirées à thèmes sont conçues pour vous offrir une parenthèse enchantée, loin du quotidien. Chaque événement propose une thématique unique, avec des intervenantes expertes et passionnées.",
          },
        ],
      },
      {
        type: "list",
        segments: [{ text: "Au programme de nos soirées :" }],
        items: [
          "Voyage Sonore : immersion relaxante avec bols tibétains et tambours chamaniques",
          "Tarot Divinatoire : lectures personnalisées pour explorer votre chemin de vie",
          "Massages & Bien-être : soins détente et rituels de relaxation profonde",
          "Ateliers Thématiques : sommeil réparateur, maternité, reconnexion à soi",
          "Moments Gourmands : assiettes gourmandes et boissons pour prolonger la convivialité",
        ],
      },
    ],
  },
  thirdSection: {
    title: "Pourquoi participer à nos Soirées ?",
    content: [
      {
        type: "paragraph",
        segments: [
          {
            text: "Nos soirées à thèmes sont bien plus que des événements : ce sont des rituels collectifs, des moments de sororité et de transformation. Dans un cadre intimiste et bienveillant, vous vivrez une expérience profonde, adaptée à vos besoins du moment.",
          },
        ],
      },
      {
        type: "paragraph",
        segments: [
          {
            text: "Que vous recherchiez la détente, l'inspiration, la guidance ou simplement un moment pour vous, nos soirées vous accueillent dans toute votre authenticité. Les groupes sont volontairement restreints pour garantir un accompagnement de qualité.",
          },
        ],
      },
      {
        type: "paragraph",
        segments: [
          {
            text: "Rejoignez-nous pour ces rendez-vous mensuels et découvrez une nouvelle façon de prendre soin de vous, dans la joie, la douceur et le partage.",
          },
        ],
      },
    ],
  },
};
